<template>
  <div class="dpo-phone-number-disclaimer">
    <p class="text-sm">
      A valid mobile phone number<button
        type="button"
        class="dpo-phone-number-disclaimer__required"
        :aria-controls="detailsId"
        :aria-expanded="detailsVisible.toString()"
        aria-label="Learn when a mobile phone number may not be required."
        @click="detailsVisible = !detailsVisible"
      >
        *
      </button>
      is now required to process your online Change-of-Address (COA) request. Your mobile phone number will be used to
      complete online Identity Proofing and Verification, in an effort to improve the security of the
      online COA process, and to identify and mitigate potential fraud. Online Identity Proofing may include a Phone
      Verification and One-Time Passcode solution and/or a Device Reputation Remote Identity Verification solution,
      as applicable.
    </p>
    <p
      v-show="detailsVisible"
      :id="detailsId"
      class="dpo-phone-number-disclaimer__note text-sm"
    >
      <span class="dpo-phone-number-disclaimer__note-marker">*</span> If you are
      moving from a Diplomatic Post Office (DPO) address, a
      mobile phone number may not be required. You can leave this field blank
      if it applies to you.
    </p>
  </div>
</template>

<script>
let nextDetailsId = 0;

export default {
  name: 'DpoPhoneNumberDisclaimer',
  data() {
    nextDetailsId += 1;

    return {
      detailsId: `dpo-phone-number-details-${nextDetailsId}`,
      detailsVisible: false,
    };
  },
};
</script>

<style scoped>
.dpo-phone-number-disclaimer__required {
  background: transparent;
  border: 0;
  color: var(--usps-digital-blue-accent);
  cursor: pointer;
  display: inline;
  font: inherit;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
  padding: 0 0 0 0.125rem;
  position: relative;
  text-decoration: none;
  vertical-align: super;
}

.dpo-phone-number-disclaimer__required::before {
  content: '';
  inset: -0.5rem;
  position: absolute;
}

.dpo-phone-number-disclaimer__identity-proofing,
.dpo-phone-number-disclaimer__note {
  margin-top: 0.5rem;
}

.dpo-phone-number-disclaimer__note-marker {
  color: var(--usps-digital-blue-accent);
  display: inline-block;
  margin-right: -0.125rem;
}
</style>
